// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.shared.types.repository.RepositoryChange

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { ChangeEntryData, ChangeEntryStore } from "./ChangeEntry.generated";

export interface RepositoryChangeData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "RepositoryChange";
    path: string;
    entries: ChangeEntryData[];
    last_modified: number;
}

export class RepositoryChangeStore {
    readonly _entity_class_name = "RepositoryChange" as const;
    path: string;
    entries: ChangeEntryStore[];
    last_modified: number;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: RepositoryChangeData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.path = wrapEntity(data.path, transport, [...chainPath, "path"]);
        this.entries = wrapEntity(data.entries, transport, [...chainPath, "entries"]);
        this.last_modified = wrapEntity(data.last_modified, transport, [...chainPath, "last_modified"]);
        makeObservable(this, {
            path: observable,
            entries: observable,
            last_modified: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }
}

registerEntity("RepositoryChange", RepositoryChangeStore);
